import React from "react";
import { HelpMessageProps } from "./help-message.props";
import HelpMessageEnum from "../../enums/help-message.enum";
import NoResultsImg from "../../assets/help-message/no_results.svg";
import NoClassesImg from "../../assets/help-message/no_classes.svg";
import "./help-message.scss";

const helpMessageImages: { [key in HelpMessageEnum]: any } = {
  [HelpMessageEnum.NO_RESULTS]: NoResultsImg,
  [HelpMessageEnum.NO_CLASSES]: NoClassesImg
};

const HelpMessage = (props: HelpMessageProps) => {
  const { message, description, icon } = props;

  return (
    <div className="help-message-wrapper">
      <img src={helpMessageImages[icon]} alt="help-message-icon" className="help-message-icon" />
      <h1 className="help-message">{message}</h1>
      {description && (
        <span data-testid="description" className="help-message-description">
          {description}
        </span>
      )}
    </div>
  );
};
export default HelpMessage;
